export const LOGIN = 'LOGIN';

export const SET_USER_AUTH = 'SET_USER_AUTH';

export const SET_USER_DATA = 'SET_USER_DATA';

export const SET_USER_LOGGED_IN = 'SET_USER_LOGGED_IN';

export const USER_LOGOUT = 'USER_LOGOUT';
